import React, { ReactNode } from "react"
import styled from "styled-components"
import { Button } from "../../atoms"
import { AosWrapper } from "../../molecules/AosWrapper"
import { animationProperties } from "../../../utils"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

interface IBannerContent {
  header: string
  title: ReactNode | string
  content: string
}
const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  height: calc(100vh + 45px);

  @media (max-width: 641px) {
    align-items: self-start;
  }
`
const Header = styled.div`
  ${(props) => props.theme.typography.cardTitle1};
  font-family: Lato;
  font-weight: 400;
  text-align: center;
  color: ${(props) => props.theme.sneakPeakTitleColor};
  line-height: 170%;
  margin-bottom: 12px;
  @media (max-width: 876px) {
    font-size: 12px;
    line-height: 100%;
    margin-bottom: 0px;
  }
  @media (max-width: 641px) {
    text-align: start;
    padding: 0 20px;
  }
`

const Title = styled.div`
  ${(props) => props.theme.typography.heroHeadline};
  font-family: Montserrat;
  font-weight: 600;
  color: ${(props) => props.theme.base};
  white-space: break-spaces;
  text-align: center;
  letter-spacing: 0.84px;

  @media (max-width: 876px) {
    font-size: 26px;
    margin-top: 16px;
  }

  @media (max-width: 641px) {
    font-size: 1.5rem;
    font-weight: 600;
    padding: 0 20px;
    text-align: start;
    white-space: normal;
    display: flex;
    flex-wrap: wrap;
    margin-top: 6px;
  }
`
const ButtonWrapper = styled.div`
  position: sticky;
  z-index: 2;

  @media (max-width: 876px) {
    button {
      width: 203px !important;
      height: 40px !important;
    }
    img {
      height: 15px;
      width: 15px;
    }
    span {
      font-weight: 600 !important;
      font-size: 14px !important;
    }
  }

  @media (max-width: 641px) {
    padding-left: 20px;
    button {
      width: 184px;
      height: 39px;
    }
    img {
      height: 13px;
      width: 13px;
    }
    span {
      font-size: 1rem;
    }
  }
`
const Content = styled.div`
  ${(props) => props.theme.typography.cardTitle1};
  font-family: Lato;
  color: ${(props) => props.theme.whiteAlpha60};
  white-space: break-spaces;
  text-align: center;
  margin: 16px 0;
  line-height: 170%;
  @media (max-width: 876px) {
    margin: 16px 0 20px 0;
    font-size: 12px;
    font-weight: 150%;
    white-space: normal;
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 641px) {
    font-size: 0.75rem;
    padding: 0 20px;
    text-align: start;
    white-space: normal;
    flex-wrap: wrap;
    margin: 12px 0;
  }
`

const ConnectButton = styled(Button)`
  margin-top: 2px;
  font-family: Lato;
  margin-bottom: 2px;
  font-weight: 600;
  line-height: 100%;
  padding: 10.5px 24px;
  height: 51px;

  @media (max-width: 876px) {
    padding: 12px 24px;
    font-size: 14px;
  }

  @media (max-width: 641px) {
  }
`

const BannerContent: React.FC<IBannerContent> = ({
  header,
  title,
  content,
}) => {
  const isDarkTheme = useDeviceTheme()
  return (
    <ContentWrapper>
      <AosWrapper offset={0} animatePreScroll={true}>
        <Header>{header.toUpperCase()}</Header>
        <Title>{title}</Title>
        <Content>{content}</Content>
      </AosWrapper>
      <ButtonWrapper>
        <AosWrapper
          animatePreScroll={true}
          animateIn={"animate__fadeInUpBig"}
          duration={animationProperties.duration + 0.2}
          delay={animationProperties.delay + 0.2}
        >
          <ConnectButton
            buttonType={"primary"}
            icon={
              isDarkTheme ? (
                <img
                  src={"/assets/icons/linked-in.svg"}
                  width={30}
                  height={30}
                />
              ) : (
                <img
                  src={"/assets/icons/linkedin-light.svg"}
                  width={30}
                  height={30}
                />
              )
            }
            onClick={() =>
              window.open("https://www.linkedin.com/company/readytowork-corp/")
            }
          >
            {"CONNECT WITH US"}
          </ConnectButton>
        </AosWrapper>
      </ButtonWrapper>
    </ContentWrapper>
  )
}

export { BannerContent }
